"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactSharedUiNext = require("@eon-funke/react-shared-ui-next");
var _SessionHandler = _interopRequireDefault(require("../../../../../utils/SessionHandler"));
var _MeterReadingEmailFeedback = require("../MeterReadingEmailFeedback/MeterReadingEmailFeedback");
var _MeterReadThanksPropTypes = _interopRequireDefault(require("./MeterReadThanksPropTypes"));
var _NPSHandler = _interopRequireDefault(require("../../../../../utils/NPSHandler"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var MeterReadThanks = function MeterReadThanks(props) {
  var _props$backButton, _props$backButton2;
  var buildAcknowledgeText = function buildAcknowledgeText() {
    if (props.missedMeter === 0) {
      return {
        counterText: props.metersRegisteredText.replace('%%TOTAL%%', props.amount.toString()),
        hint: null
      };
    }
    if (props.fromToMetersRegisteredText) {
      return {
        counterText: props.fromToMetersRegisteredText.replace('%%SUCCESS%%', (props.amount - props.missedMeter).toString()).replace('%%TOTAL%%', props.amount.toString()),
        hint: props.revisitHint
      };
    }
    return null;
  };
  var acknowledgeTextData = buildAcknowledgeText();
  (0, _react.useEffect)(function () {
    (0, _NPSHandler.default)();
    _SessionHandler.default.destroySession(false);
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "meter-read-thanks__flex-center-vertically"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "meter-read-thanks__headline"
  }, props.thankYouText), /*#__PURE__*/_react.default.createElement("p", {
    className: "meter-read-thanks__description"
  }, "".concat(props.description, " ").concat((acknowledgeTextData === null || acknowledgeTextData === void 0 ? void 0 : acknowledgeTextData.hint) ? acknowledgeTextData.hint : '')), (acknowledgeTextData === null || acknowledgeTextData === void 0 ? void 0 : acknowledgeTextData.counterText) && /*#__PURE__*/_react.default.createElement("div", {
    className: "meter-read-thanks__container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "meter-read-thanks__container__arrow"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "meter-read-thanks__container__text"
  }, acknowledgeTextData.counterText)), props.emailFeedbackState === _MeterReadingEmailFeedback.EmailFeedbackStatusEnum.ACCEPTED && props.feedbackEmail && /*#__PURE__*/_react.default.createElement("div", {
    className: "meter-read-thanks__container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "meter-read-thanks__container__arrow"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "meter-read-thanks__container__text"
  }, props.emailConfirmationText, /*#__PURE__*/_react.default.createElement("span", {
    className: "meter-read-thanks__container__email"
  }, props.feedbackEmail))), props.okoEmail && /*#__PURE__*/_react.default.createElement("div", {
    className: "meter-read-thanks__container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "meter-read-thanks__container__arrow"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "meter-read-thanks__container__text"
  }, props.okoConfirmationText1, /*#__PURE__*/_react.default.createElement("span", {
    className: "meter-read-thanks__container__email"
  }, props.okoEmail), props.okoConfirmationText2)), /*#__PURE__*/_react.default.createElement("div", {
    className: "meter-read-thanks__button-container"
  }, /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Link, {
    "data-qa": "logOutLink",
    isButton: true,
    version: (_props$backButton = props.backButton) === null || _props$backButton === void 0 ? void 0 : _props$backButton.version,
    href: props.returnUrl
  }, ' ', (_props$backButton2 = props.backButton) === null || _props$backButton2 === void 0 ? void 0 : _props$backButton2.label))));
};
MeterReadThanks.propTypes = _MeterReadThanksPropTypes.default;
var _default = exports.default = MeterReadThanks;